import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { EditorState, ContentState, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import DOMPurify from 'dompurify'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Loading from '../ui/Loading.js'
import Security from '../../commons/security/Security.js'
import { FormattedMessage, injectIntl } from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';

class PoliticasPrivacidadAbm extends Component {
	constructor(props) {
		super(props);
		this.ajaxHandler = new AjaxHandler();

		this.state = {
			redirectTo: null,
			props: this.props,
			formData: {
				id: 0,
				titulo: '',
				contenido: '',
				version: '',
			},
			editorState: EditorState.createEmpty(),
			errors: [],
			loading: false
		};

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleInputFormChange = this.handleInputFormChange.bind(this);
		this.handleEditorChange = this.handleEditorChange.bind(this);

		this.formValidation = new FormValidation({
			component: this,
			validators: {
				'formData.titulo': (value) => Validator.notEmpty(value),
				'formData.contenido': (value) => Validator.notEmpty(value),
				'formData.version': (value) => Validator.notEmpty(value),
			}
		});
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
	}

	componentWillMount() {
		var action = this.state.props.action;
		var puedeCrear = Security.hasPermission('POLITICAS_PRIVACIDAD_CREAR');
		var puedeVisualizar = Security.hasPermission('POLITICAS_PRIVACIDAD_VISUALIZAR');

		if ((puedeCrear && (action === 'ADD' || action === 'NUEVA_VERSION')) ||
			(puedeVisualizar && action === 'VIEW')) {
			this.ajaxHandler.subscribe(this);
			this.initForm();
		} else {
			this.setState({ redirectTo: '/error' });
		}
	}

	htmlToEditorState(html) {
		var blocksFromHtml = htmlToDraft(html || '');
		var contentState = ContentState.createFromBlockArray(
			blocksFromHtml.contentBlocks,
			blocksFromHtml.entityMap
		);
		return EditorState.createWithContent(contentState);
	}

	initForm() {
		this.setState({ loading: true });
		var component = this;
		var action = this.state.props.action;
		var id = this.state.props.match.params.id;

		Promise.all([
			(action === 'VIEW' || action === 'NUEVA_VERSION') ? this.ajaxHandler.getJson('/politicas-privacidad/' + id) : null,
		]).then(function(data) {
			if (data[0]) {
				var politica = data[0];
				if (action === 'NUEVA_VERSION') {
					component.setState({
						formData: {
							id: 0,
							titulo: politica.titulo,
							contenido: politica.contenido,
							version: '',
						},
						editorState: component.htmlToEditorState(politica.contenido),
					});
				} else {
					component.setState({
						formData: politica,
						editorState: component.htmlToEditorState(politica.contenido),
					});
				}
			}
		}).catch(function() {
			component.exit();
		}).finally(function() {
			component.setState({ loading: false });
		});
	}

	handleInputFormChange(event) {
		var target = event.target;
		var name = target.name;
		var value = target.type === 'checkbox' ? target.checked : target.value;
		var formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = value;
		this.setState({ formData: formDataCopy });
	}

	handleEditorChange(editorState) {
		var html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
		var formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy['contenido'] = html;
		this.setState({ editorState: editorState, formData: formDataCopy });
	}

	handleSubmit(event) {
		this.setState({ loading: true });
		var component = this;
		this.ajaxHandler.fetch('/politicas-privacidad', {
			method: 'POST',
			body: JSON.stringify({
				titulo: this.state.formData.titulo,
				contenido: this.state.formData.contenido,
				version: this.state.formData.version,
			}),
		}).then(function(response) {
			if (response.status !== 400) {
				component.exit();
			} else {
				response.json().then(function(data) {
					component.setState({ errors: data.detalle });
				});
			}
			window.scrollTo(0, 0);
		}).catch(function(error) {
			component.ajaxHandler.handleError(error);
		}).finally(function() {
			component.setState({ loading: false });
		});
		event.preventDefault();
	}

	exit() {
		this.setState({ redirectTo: '/politicasPrivacidad' });
	}

	render() {
		this.formValidation.validate();
		var formData = this.state.formData;
		var validationState = this.formValidation.state;
		var action = this.props.action;
		var isView = action === 'VIEW';
		var isEditable = action === 'ADD' || action === 'NUEVA_VERSION';

		return (
			<React.Fragment>
				{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
				{this.state.loading && <Loading />}
				<div className="row">
					<div className="col-md-12">
						<div className="alert alert-danger" role="alert" hidden={this.state.errors.length === 0}>
							{this.state.errors.map(function(e, i) {
								return <li key={i}><FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings['errors.default'])} /></li>
							})}
						</div>

						{isView &&
							<div className="alert alert-info" role="alert">
								<i className="fa fa-lock mr-1"></i>
								<FormattedMessage id="politicasPrivacidad.aviso_inmutable" defaultMessage="Las políticas de privacidad no pueden modificarse. Para actualizar el contenido, generá una nueva versión." />
							</div>
						}

						<form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
							<div className="form-body">
								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">
											<h4 className="form-section">
												<i className="icon-home"></i>
												{action === 'NUEVA_VERSION'
													? <FormattedMessage id="politicasPrivacidad.nueva_version" defaultMessage="Nueva Versión" />
													: <FormattedMessage id="Datos_Generales" defaultMessage="Datos Generales" />
												}
												{isEditable &&
													<div className="float-right" style={{ fontSize: '14px' }}>
														* <FormattedMessage id="campos_requeridos" defaultMessage="campos requeridos" />
													</div>
												}
											</h4>

											{action === 'NUEVA_VERSION' &&
												<div className="alert bg-fleet text-white border-0" role="alert">
													<i className="fa fa-info-circle mr-1"></i>
													<FormattedMessage id="politicasPrivacidad.aviso_nueva_version" defaultMessage="Se creará una nueva versión. La versión anterior quedará como histórica." />
												</div>
											}

											<div className="row">
												{/* Título */}
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-3 label-control col-form-label" htmlFor="titulo">
															<FormattedMessage id="politicasPrivacidad.titulo_campo" defaultMessage="Título" />
															{isEditable && '*'}:
														</label>
														<div className="col-md-9">
															{isView ? (
																<div className="form-control-static col-form-label form-value">{formData.titulo}</div>
															) : (
																<div>
																	<input
																		type="text"
																		className="form-control"
																		id="titulo"
																		name="titulo"
																		placeholder={this.props.intl.formatMessage({ id: 'politicasPrivacidad.titulo_campo', defaultMessage: 'Título' })}
																		value={formData.titulo}
																		onChange={this.handleInputFormChange}
																	/>
																	<div className="help-block text-danger field-message" hidden={validationState.formData.titulo.pristine || validationState.formData.titulo.valid}>
																		{validationState.formData.titulo.message}
																	</div>
																</div>
															)}
														</div>
													</div>
												</div>

												{/* Versión */}
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-3 label-control col-form-label" htmlFor="version">
															<FormattedMessage id="politicasPrivacidad.version" defaultMessage="Versión" />
															{isEditable && '*'}:
														</label>
														<div className="col-md-9">
															{isView ? (
																<div className="form-control-static col-form-label form-value">{formData.version}</div>
															) : (
																<div>
																	<input
																		type="text"
																		className="form-control"
																		id="version"
																		name="version"
																		placeholder={this.props.intl.formatMessage({ id: 'politicasPrivacidad.version', defaultMessage: 'Ej: 2.0' })}
																		value={formData.version}
																		onChange={this.handleInputFormChange}
																	/>
																	<div className="help-block text-danger field-message" hidden={validationState.formData.version.pristine || validationState.formData.version.valid}>
																		{validationState.formData.version.message}
																	</div>
																</div>
															)}
														</div>
													</div>
												</div>
											</div>

											{/* Contenido */}
											<div className="row">
												<div className="col-md-12">
													<div className="form-group">
														<label className="col-form-label">
															<FormattedMessage id="politicasPrivacidad.contenido" defaultMessage="Contenido" />
															{isEditable && '*'}:
														</label>
														{isView ? (
															<div
																className="border rounded p-3"
																style={{ minHeight: '300px', backgroundColor: '#fff', lineHeight: '1.6' }}
																dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formData.contenido || '') }}
															/>
														) : (
															<div>
																<div style={{ border: '1px solid #ced4da', borderRadius: '4px' }}>
																	<Editor
																		editorState={this.state.editorState}
																		onEditorStateChange={this.handleEditorChange}
																		editorStyle={{ minHeight: '300px', padding: '0 12px' }}
																		toolbar={{
																			options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'history'],
																			inline: { options: ['bold', 'italic', 'underline', 'strikethrough'] },
																			blockType: { options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'Blockquote'] },
																		}}
																	/>
																</div>
																<div className="help-block text-danger field-message" hidden={validationState.formData.contenido.pristine || validationState.formData.contenido.valid}>
																	{validationState.formData.contenido.message}
																</div>
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">
											<div className="text-cd text-right">
												{isView && Security.hasPermission('POLITICAS_PRIVACIDAD_CREAR') && formData.activo === 1 &&
													<button
														type="button"
														className="btn btn-primary mr-1"
														onClick={() => this.setState({ redirectTo: '/politicasPrivacidad/' + formData.id + '/nueva-version' })}
													>
														<i className="fa fa-copy"> </i> <FormattedMessage id="politicasPrivacidad.nueva_version" defaultMessage="Nueva Versión" />
													</button>
												}
												{isEditable &&
													<button type="submit" className="btn btn-primary mr-1" disabled={!validationState.form.valid}>
														<i className="fa fa-check-circle"> </i> <FormattedMessage id="Guardar" defaultMessage="Guardar" />
													</button>
												}
												<button type="button" className="btn btn-danger" onClick={this.exit.bind(this)}>
													<i className="fa fa-times-circle"></i> {isView
														? this.props.intl.formatMessage({ id: 'Volver', defaultMessage: 'Volver' })
														: this.props.intl.formatMessage({ id: 'Cancelar', defaultMessage: 'Cancelar' })
													}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default injectIntl(PoliticasPrivacidadAbm);
